module.exports = __webpack_public_path__ + "img/dynastar.c0834fbf.svg";